import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "firebase";
import "./registerServiceWorker";
import VueConfetti from "vue-confetti";
import VModal from "vue-js-modal";

Vue.config.productionTip = false;

Vue.use(VModal);
Vue.use(VueConfetti);

let app = "";
// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyCl95ZMppDALxpq9EexzYDnx08CTxznIuU",
  authDomain: "tc-disrupt-hackathon-2019.firebaseapp.com",
  databaseURL: "https://tc-disrupt-hackathon-2019.firebaseio.com",
  projectId: "tc-disrupt-hackathon-2019",
  storageBucket: "",
  messagingSenderId: "441375928507",
  appId: "1:441375928507:web:4c07507f8a7e738420799e"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount("#app");
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
